import { CatNivelSeguridadesService } from './../../servicios/cat-nivel-seguridades.service';
import { ConsultaHistoricoMigradoInput, Privilegios, ConsultaHistoricoMovimientosInput, Medidores, ConsultaLecturasInput, BuscaBitacoraMasivoInput
        , HistoricoLecturasInput, ConsultaHistoricoMigrado, ConsultaOrdenesTrabajo, ConsultaOrdenesTrabajoInput, EtapasOrdenes
        , Domiciliacion } from './../../entidades/entidades';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EstadoCuentaInformacionService } from "../../servicios/estado-cuenta-informacion.service";
import { ParametrosService } from "../../servicios/parametros.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { AguaBloqueosService } from "../../servicios/agua-bloqueos.service";
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { AuthenticationService } from '../../../app/servicios';
import autoTable from 'jspdf-autotable'

import {
  EstadoCuentaInformacion,
  EstadoCuentaInformacionInput,
  AuxJasper,
  ParametroJasper,
  Config,
  AguaBloqueos,
  CargosDetallesInput,
  RegistroBitacoraInput,
} from "../../entidades/entidades";
import { JasperService } from "../../servicios/jasper.service";
import { BuscaBitacoraInput, BusquedaContratosInput } from '../../entidades/entidades';
import { async } from '@angular/core/testing';
import { BuscaBitacoraMasivoService } from 'app/servicios/busca-bitacora-masivo.service';
import { MenuItem } from 'primeng/api';
import { HistoricoLecturasService } from 'app/servicios/historico-lecturas.service';
import Utils from "../../shared/utilerias/utils";
import jsPDF from 'jspdf';
import { ConsultaHistoricoMigradoService } from 'app/servicios/consulta-historico-migrado.service';
import { ConsultaOrdenesTrabajoService } from 'app/servicios/ordenes-trabajo.service';
import { RegistraSolicitudesService } from 'app/servicios/registra-solicitudes.service';
import { FlujoOrdenesService } from 'app/servicios/flujo-ordenes.service';
import { PrivilegiosService } from 'app/servicios/privilegios.service';



var $: any;

@Component({
  selector: "app-estado-cuenta-informacion",
  templateUrl: "./estado-cuenta-informacion.component.html",
  styleUrls: ["./estado-cuenta-informacion.component.css"]
})

export class EstadoCuentaInformacionComponent implements OnInit {
  private _jasperService: JasperService;
  public jasperInputCatTipoDoc$ = new EventEmitter<AuxJasper>();
  public auxJasper: AuxJasper;
  muestraMensaje = new MuestraMensaje();
  estadoCuentaInformacionForm: FormGroup;
  display: boolean = false;
  displayHistoricoAdeudo: boolean = false;
  displayHistoricoMiracion: boolean = false;
  displayHistoricoMovimientos: boolean = false;
  displayMedidores: boolean = false;
  displayObservaciones:boolean = false;
  displayOrdenes: boolean = false;
  displayDomiciliacion: boolean = false;
  public  ConsultaOrdenesInput$ = new EventEmitter<ConsultaOrdenesTrabajo[]>();
  public ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
  public consultaOrdenesTrabajo: ConsultaOrdenesTrabajo[] = [];
  public  etapasOrdenesInput$ = new EventEmitter<EtapasOrdenes[]>();
  @ViewChild('reimpresionChild') reimpresionComponent: any;
  public EtapasOrdenes: EtapasOrdenes[] = [];
  public OrdenTrabajo: ConsultaOrdenesTrabajo ;
  displayContratos: boolean = false;
  displayLecturas: boolean = false;
  displayPagos: boolean = false;
  displayreimpresion: boolean = false;
  resultadoHistoricoMigrado: any[] = [];
  medidoresInput: Medidores = new Medidores;
  public medidoresInput$ = new EventEmitter<Medidores>();
  observacionesInput: Medidores = new Medidores;
  public observacionesInput$ = new EventEmitter<Medidores>();
  public consultaLectura: ConsultaLecturasInput;
    itemsMenu: MenuItem[];
  public historicoLecturasInput$ = new EventEmitter<HistoricoLecturasInput>();
  public domiciliacion$ = new EventEmitter<Domiciliacion>();
  historicoLecturasInput: HistoricoLecturasInput;
  historicoMigrado: ConsultaHistoricoMigrado;

  usuario: string;
  showDialog() {
    this.display = true;
  }
  showHistoricoAdeudo(){
    this.displayHistoricoAdeudo = true;
  }
  showPagos(){
    this.displayPagos= true;
  }
  showHistoricoMigracion(){
    this.displayHistoricoMiracion = true;
  }
  showHistoricoMovimientos(){
    this.displayHistoricoMovimientos = true;
  }
  async showHistoricoMedidores(){
    //Carga medidores
    this.medidoresInput.idAgua = this.idAgua;
    this.medidoresInput$.emit(this.medidoresInput);
    this.displayMedidores = true;
  }
  showDialog1() {
    this.display1 = true;
  }
  showContratos() {
    this.displayContratos = false;
  }
  showLecturas() {	 
    this.displayLecturas = true;
  }

  bandera: boolean = false;
  @Input("edoAdeudo") edoAdeudo: boolean = false;
  @Input("LicAdeudo") LicAdeudo: boolean = false;
  @Input("HisAduedo") HisAduedo: boolean = false;
  @Input("HisPagos") HisPagos: boolean = false;

  aguaBloqueos: AguaBloqueos[];
  public aguaBloq: AguaBloqueos;
 
  public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
  public cargosDetallesInputLimpio: CargosDetallesInput;
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
  public registroBitacora = new RegistroBitacoraInput();
  //public idNivel;
  public buscaBitacoraInput$ = new EventEmitter<BuscaBitacoraInput>();

  public consultaHistoricoMigradoInput$ = new EventEmitter<ConsultaHistoricoMigrado>();
  public consultaHistoricoMovimientosInput$ = new EventEmitter<ConsultaHistoricoMovimientosInput>();

  public busquedaContratosInput$ = new EventEmitter<BusquedaContratosInput>();
  public buscaBitacoraMasivoInput: BuscaBitacoraMasivoInput;
  
  @Input("estadoCuentaInformacionInput") estadoCuentaInformacionInput: EstadoCuentaInformacionInput;
  @Input("esCajaAgua") esCajaAgua: boolean = false;
  @Output("estadoCuentaInformacionOutput") estadoCuentaInformacionOutput: EventEmitter<EstadoCuentaInformacion>;

  display1: boolean = false;

  estadoCuentaTable: any;
  public idAgua: number;
  public cuentaAgua: number;
  public derivada: number
  public anio: number
  public periodo: number
  public iAmbiente: number;
  public idAguaEnvio: number;


  @Output() eliminaProgressBar = new EventEmitter();
  @Output()ImprimeRecibosEmit: EventEmitter<ConsultaLecturasInput>;

  public progressBar1 = false;
  showBar() {
      this.progressBar1 = true;
  }

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private estadoCuentaInformacionService: EstadoCuentaInformacionService,
    private parametrosService: ParametrosService,
    private router: Router,
    private privilegiosService: PrivilegiosService,
    private consultaOrdenesTrabajoService: ConsultaOrdenesTrabajoService,
    private route: ActivatedRoute,
    private aguaBloqueosService: AguaBloqueosService,
    private flujoOrdenesService: FlujoOrdenesService,
    private registraSolicitudesService: RegistraSolicitudesService,
    private registroBitacoraService: RegistroBitacoraService,
    private catNivelSeguridadesService:CatNivelSeguridadesService,
    private buscaBitacoraMasivoService: BuscaBitacoraMasivoService,
    private historicoLecturasService: HistoricoLecturasService,
    private consultaHistoricoMigradoService: ConsultaHistoricoMigradoService,
    
  ) {
    this.estadoCuentaInformacionOutput = new EventEmitter()
  }

   async ngOnInit() {

    this.estadoCuentaInformacionForm = this.formBuilder.group({
      idAgua: [undefined],
      cuentaAgua: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cuentaAnterior: [undefined],
      nombreCompleto: [undefined],
      domicilio: [undefined],
      cp: [undefined],
      ruta: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      numeroMedidor: [undefined],
      fechaInstalacion: [undefined],
      claveCatastral: [undefined],
      rfc: [undefined],
      periodo: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      tipoPeriodo: [undefined],
      anio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      fechaVencimiento: [undefined],
      derivada: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      anomalia: [undefined],
      observaciones: [undefined],
      diametro: [undefined],
      tipoServicio: [undefined],
      proximaLectura: [undefined],
      tipoUso: [undefined],
      lecturaIni: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      lecturaFin: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      periodoConsumoIni: [undefined],
      periodoConsumoFin: [undefined],
      consumo: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      total: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      periodoadeudo: [undefined],
      nombreLocal: [undefined],
      conDomic: [undefined],
      tipoConsumo: [undefined],
      consecuti: [undefined],
    });
   /*let objUrl = new Privilegios();
    objUrl.descripcion = this.router.url;
    var objNivelSeg = await this.catNivelSeguridadesService
      .GetNivelPorPrivilegio(objUrl)
      .toPromise();
    if (objNivelSeg[0] != undefined) {
      this.idNivel = objNivelSeg[0].id;
    }*/

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    this.itemsMenu = [

      // { label: "Liquidación", command: (event) => { this.imprimirLiquidacion(); }, visible: this.LicAdeudo },
      // { separator: true },
      { label: "Histórico de Adeudo", command: (event) => { this.HistoricoAduedo(); }, visible: this.HisAduedo },
      { separator: true },

      { label: "Pagos", command: (event) => { this.PagosRealizados(); }, visible: this.HisPagos },
      { separator: true },
      
      
      // { label: "Contratos", command: (event) => { this.buscaContrato(); }, visible: this.LicAdeudo },
      // { separator: true },
      { label: "Pagos Mig.", command: (event) => { this.historicoMigracion(); }, visible: this.LicAdeudo },
      { separator: true },
      { label: "Consumos Mig.", command: (event) => { this.buscaLecturas(this.idAgua, this.cuentaAgua); }, visible: this.LicAdeudo },
      { separator: true },  
      { label: "Bitacora", command: (event) => { this.buscaBitacora(); }, visible: this.LicAdeudo },
      { separator: true },  
      { label: "Ordenes de Trabajo", command: (event) => { this.abreOrdenesTrabajo(); }, visible: true },  
      { separator: true },  
      { label: "Observaciones", command: (event) => { this.buscaObservacion(); }, visible: this.edoAdeudo },
      { separator: true },      
      { label: "Expediente", command: (event) => { this.visorExpediente(); }, visible: this.edoAdeudo },
      { separator: true },
      { label: "CARTOWEB", command: (event) => { this.abreCartoWeb(); }, visible: true },
      { separator: true },
      //{ label: "Domiciliación", command: (event) => { this.abreDomiciliacion(); }, visible: true },
      //{ separator: true },
      // { label: "Saldo Histórico de Movimientos", command: (event) => { this.HistoricoMovimientos(); }, visible: this.LicAdeudo },
      // { separator: true },
      // { label: "Medidores", command: (event) => { this.showHistoricoMedidores(); }, visible: this.LicAdeudo },
      // { separator: true },
      // { label: "Imprimir", command: () => this.imprimir(), visible: this.edoAdeudo },
      // { separator: true },      
      // { label: "Estado de Adeudo", command: (event) => { this.imprimirRecibo(); }, visible: this.edoAdeudo },
      // { separator: true },
    ];

    let config: Config = JSON.parse(localStorage.getItem("config"));

    this.iAmbiente = config.IdAmbiente;
  }

  ngOnChanges() {
    if (this.estadoCuentaInformacionInput) {
      this.getEstadoCuentaInformacionAll(this.estadoCuentaInformacionInput);
    }
  }

  async visorExpediente() {
    try {
      //consultamos paramtero url
      const datoRetorno = await this.parametrosService
      .getSingle("URL_EXPEDIENTES")
      .toPromise();

      if(datoRetorno) window.open(datoRetorno.valorCaracter + this.cuentaAgua, '_blank');
      

      } catch (e) {
          if (e.response) throw { message: e.response.data };
    } finally {
      console.log("visorExpediente");
    }

  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async getEstadoCuentaInformacionAll(estadoCuentaInformacionInput: EstadoCuentaInformacionInput) {
    try {
      const datoRetorno = await this.estadoCuentaInformacionService
        .getBusquedas(estadoCuentaInformacionInput)
        .toPromise(); 
      this.estadoCuentaInformacionForm.patchValue(datoRetorno[0]);
      this.estadoCuentaTable = datoRetorno;
      if(parseInt(this.estadoCuentaTable[0].derivada) === 0 && this.estadoCuentaTable[0].padre)
        this.estadoCuentaTable[0].prorrateo = "Es un contrato padre"
      else if(parseInt(this.estadoCuentaTable[0].derivada) === 0 && !this.estadoCuentaTable[0].padre)
        this.estadoCuentaTable[0].prorrateo= "Es un contrato normal"
      else 
      this.estadoCuentaTable[0].prorrateo = "Es un contrato hijo, el contrato padre es: "+this.estadoCuentaTable[0].derivada ;
      this.estadoCuentaInformacionOutput.emit(datoRetorno);
      
      this.cuentaAgua = datoRetorno[0].cuentaAgua;
      this.derivada = datoRetorno[0].derivada;
      this.anio = datoRetorno[0].anio;
      this.periodo = datoRetorno[0].periodo;

      /* Validacion que muestra un mensaje cuando la cuenta esta bloqueada */
      if (datoRetorno[0].bloqueoVigente != null) {
        this.muestraMensaje.warning("Esta cuenta está bloqueada", "top", "center");
      }
      /* Validacion que muestra un mensaje cuando la cuenta esta cancelada */
      else if (datoRetorno[0].estatus == "CANCELADO") {
        this.muestraMensaje.warning("Esta cuenta está cancelada", "top", "center");
      }

      if (datoRetorno[0].conServicios) {
        this.muestraMensaje.warning("Contrato con servicios pendientes de pago", "top", "center");
      }

      if (this.estadoCuentaTable[0].proximaLectura != "") {
        //Conversion del formato de fecha
        let aux = this.estadoCuentaTable[0].proximaLectura;
        let fechaSeparada = aux.split(' ');
        let fechaSeparada1 = fechaSeparada[0].split('-');
        let fechaSeparada2 = fechaSeparada[2].split('-');
        let fechaFinal = fechaSeparada1[2] + '-' + fechaSeparada1[1] + '-' + fechaSeparada1[0] + ' ' + fechaSeparada2[2]
          + '-' + fechaSeparada2[1] + '-' + fechaSeparada2[0];
        this.estadoCuentaTable[0].proximaLectura = fechaFinal;
      }

      if (this.estadoCuentaTable[0].periodoadeudo != null) {
        //Conversion del formato de fecha (Periodo Consumo)
        let aux = this.estadoCuentaTable[0].periodoadeudo;
        let fechaSeparada = aux.split(' ');
        let fechaSeparada1 = fechaSeparada[0].split('-');
        let fechaSeparada2 = fechaSeparada[2].split('-');
        let bimestre = "BIM";
        let fechaFinal = bimestre + '-' + fechaSeparada1[2] + '-' + fechaSeparada1[1] + ' ' + fechaSeparada[1] + ' '
          + bimestre + '-' + fechaSeparada2[2] + '-' + fechaSeparada2[1];
        this.estadoCuentaTable[0].periodoadeudo = fechaFinal;
      }

      this.idAgua = datoRetorno[0].idAgua;
      this.bandera = true;

      this.aguaBloq = new AguaBloqueos();
      this.aguaBloq.idAgua = datoRetorno[0].idAgua;
      this.getAllAguaBloqueos(this.aguaBloq);

    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getEstadoCuentaInformacionAll");
    }
  }

  async getEstadoCuentaInformacion(id: number) {
  
   
    try {
      const datoRetorno = await this.estadoCuentaInformacionService
        .getSingle(id)
        .toPromise();
      this.estadoCuentaInformacionForm.patchValue(datoRetorno);


    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getEstadoCuentaInformacion");
    }

  }

  async getAllEstadoCuentaInformacion() {

    try {

      const datoRetorno = await this.estadoCuentaInformacionService.getAll().toPromise();

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllEstadoCuentaInformacion");
    }
  }
  async imprimir() {
    try {
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "EstadodeAdeudos";
      this.auxJasper.JasperReport.tipo = "pdf";
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAgua + "";
      await this.auxJasper.ParametroJasper.push(_id_agua);

      this.showDialog();

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }

  async imprimirResumen() {
    try {
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "EstadodeAdeudosResumen";
      this.auxJasper.JasperReport.tipo = "pdf";
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAgua + "";
      await this.auxJasper.ParametroJasper.push(_id_agua);

      this.showDialog();

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }
  async imprimirLiquidacion(){
    
    try {
      //ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "liquidacion";
      this.auxJasper.JasperReport.tipo = "pdf";
      this.auxJasper.JasperReport.imprimir = false;
      this.usuario = this.authenticationService.currentUserValue.id.toString();
      
      let _id_usuario = new ParametroJasper();
      _id_usuario.nombre = "usuario_liquidacion";
      _id_usuario.valor = this.usuario + "";
      await this.auxJasper.ParametroJasper.push(_id_usuario);

      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "id_agua";
      _id_agua.valor = this.idAgua + "";
      await this.auxJasper.ParametroJasper.push(_id_agua);

      //await $(".solicitud").modal("show"); //Para mostrar en forma de Poppup
      //this.router.navigateByUrl("componentes/visor", { state: this.auxJasper.JasperReport }); //Para mostrarlo con pagina independiente
      this.showDialog();
      this.registroBitacora.idAgua = this.idAgua;
      this.registroBitacora.idMovAsegurar = 2;
      this.registroBitacora.accion = "CONSULTA LIQUIDACION";
      const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();




      
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }

  }

  async buscaBitacora ()
  {
    try {

      this.showDialog1();

      let buscaBitacora = new BuscaBitacoraInput();
      buscaBitacora.cuentaAgua = this.idAgua;
      buscaBitacora.fechaIn = new Date();
      buscaBitacora.fechaFin = new Date();
      this.buscaBitacoraInput$.emit(null);
      this.buscaBitacoraInput$.emit(buscaBitacora);

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    } finally {
      console.log('buscaBitacora');
    }


  }

  async buscaContrato ()
  {
    try {

      this.showContratos();
      let buscaContrato = new BusquedaContratosInput();
      buscaContrato.cuentaAgua = this.cuentaAgua.toString();
      this.busquedaContratosInput$.emit(null);
      this.busquedaContratosInput$.emit(buscaContrato);

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    } finally {
      console.log('buscaContrato');
    }


  }

  

  async HistoricoMovimientos(){
    try{
      this.showHistoricoMovimientos();
      
      await this.consultaHistoricoMovimientosInput$.emit(null);


      let buscaHistorico = new ConsultaHistoricoMovimientosInput();
      buscaHistorico.cuenta = this.cuentaAgua;
      buscaHistorico.derivada = this.derivada;

      await this.consultaHistoricoMovimientosInput$.emit(buscaHistorico);
      
    }catch (error){
      if(error.response) throw { message: error.reposnse.data};
      else throw error
    }
  }

  async PagosRealizados()
  {
    try {
      this.showPagos();  
      this.idAguaEnvio = this.idAgua;

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por PagosRealizados");
    }
  }

  async HistoricoAduedo(){
    try
    { 

      this.showHistoricoAdeudo();

      // console.log('idAgua: ', this.idAgua)
      // this.router.navigate(['componentes/historico-adeudos'], 
      //   {
      //     state: { example: this.idAgua }
      //   });


      await this.cargosDetallesInput$.emit(null);
      //Carga detalle adeudos
      let cargosDetallesInput = new CargosDetallesInput();
      cargosDetallesInput.idAgua = this.idAgua;
      cargosDetallesInput.idEstatus = null;
      cargosDetallesInput.parametrosAdicionales = '{"historico": true}';
      await this.cargosDetallesInput$.emit(cargosDetallesInput);
      // Registro de Bitacora
      this.registroBitacora.idAgua = this.idAgua;
      this.registroBitacora.accion = "CONSULTA HISTÓRICO DE ADEUDOS";
      await this.registroBitacoraService.add(this.registroBitacora).toPromise();
  
    }catch (error){
      if(error.response) throw { message: error.reposnse.data};
      else throw error
    }
  }
  async getAllAguaBloqueos(aguaBloqueos: AguaBloqueos) {
    try {
      /*const datoRetorno = await this.aguaBloqueosService.getSingle(aguaBloqueos.idAgua).toPromise();
      this.aguaBloqueos = datoRetorno;*/
     
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllAguaBloqueos");
    }
  }

  async imprimirRecibo()
  {
    // this.buscaBitacoraMasivoInput = new BuscaBitacoraMasivoInput();

    // this.buscaBitacoraMasivoInput.cuentaAgua = this.cuentaAgua;

    // const datoRetorno = await this.buscaBitacoraMasivoService.getBusquedas(this.buscaBitacoraMasivoInput).toPromise();
    // console.log(datoRetorno);

    try {
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "EstadoDeCuenta";
      this.auxJasper.JasperReport.tipo = "pdf";
      
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAgua + "";
      await this.auxJasper.ParametroJasper.push(_id_agua);

      let _anio = new ParametroJasper();
      _anio.nombre = "_anio";
      _anio.valor = this.anio + "";
      await this.auxJasper.ParametroJasper.push(_anio);
      
      let _periodo = new ParametroJasper();
      _periodo.nombre = "_periodo_parcialidad";
      _periodo.valor = this.periodo + "";
      await this.auxJasper.ParametroJasper.push(_periodo);

      let reimpresion = new ParametroJasper();
      reimpresion.nombre = "reimpresion";
      reimpresion.valor = "true";
      await this,this.auxJasper.ParametroJasper.push(reimpresion);

      this.showDialog();

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }


  async buscaObservacion() {
		    //Carga medidores
        this.observacionesInput.idAgua = this.idAgua;
        this.observacionesInput$.emit(this.observacionesInput);
        this.displayObservaciones = true;
  }

  async abreCartoWeb() {
        var Token: string = JSON.parse(localStorage.getItem("currentUser")).token;
        var url = Utils.getBaseUrlCartoWeb() +"?token=" + Token + "&contrato=" + this.cuentaAgua + "&idagua=" + this.idAgua;
        window.open(url, "_blank");
  }

  
  async buscaLecturas(idAgua: number, cuentaAgua: number) {
    try {
      this.showLecturas();
      let buscaLecturas = new HistoricoLecturasInput();
      buscaLecturas.IdAgua = idAgua;
      buscaLecturas.CuentaAgua = Number(cuentaAgua);
      const datoRetorno = await this.historicoLecturasService
        .getBusquedasByInput(buscaLecturas)
        .toPromise();
      this.historicoLecturasInput = datoRetorno;
      this.historicoLecturasInput$.emit(this.historicoLecturasInput);
      return datoRetorno; // Devolver los datos
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    } finally {
      console.log("buscaLecturas completado");
    }
}

  async ExportarPDF() {
    try {
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "Historico_Lecuras";
      this.auxJasper.JasperReport.tipo = "pdf";
      
      let _cuenta_agua = new ParametroJasper();
      _cuenta_agua.nombre = "_cuenta_agua";
      _cuenta_agua.valor = this.cuentaAgua + "";
      await this.auxJasper.ParametroJasper.push(_cuenta_agua);

      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAgua + "";
      await this.auxJasper.ParametroJasper.push(_id_agua);

      this.showDialog();

    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }
  }


async historicoMigracion() {
  this.showHistoricoMigracion();
  await this.consultaHistoricoMigradoInput$.emit(null);

  let buscaHistorico = new ConsultaHistoricoMigradoInput();
  buscaHistorico.cuenta = this.cuentaAgua;
  buscaHistorico.derivada = this.derivada;
  buscaHistorico.idAmbiente = this.iAmbiente;

  const datoRetorno = await this.consultaHistoricoMigradoService.getBusquedas(buscaHistorico).toPromise();
  
  await this.consultaHistoricoMigradoInput$.emit(datoRetorno);
  return datoRetorno; // Devolver los datos históricos migrados
}


async ExportarMigradosPDF() {
  try {
    this.auxJasper = new AuxJasper();
    this.auxJasper.JasperReport.nombreReporte = "MigradosPagos";
    this.auxJasper.JasperReport.tipo = "pdf";

    let _id_agua = new ParametroJasper();
    _id_agua.nombre = "_id_agua";
    _id_agua.valor = this.idAgua + "";
    await this.auxJasper.ParametroJasper.push(_id_agua);

    let _cuenta_agua = new ParametroJasper();
      _cuenta_agua.nombre = "_cuenta_agua";
      _cuenta_agua.valor = this.cuentaAgua + "";
      await this.auxJasper.ParametroJasper.push(_cuenta_agua);

    this.showDialog();

  } catch (error) {
    if (error.response) throw { message: error.response.data };
    else throw error;
  }
}

async ExportarPDFHistoricoAdeudo() {
  try {
    this.auxJasper = new AuxJasper();
    this.auxJasper.JasperReport.nombreReporte = "HistoricoAdeudos";
    this.auxJasper.JasperReport.tipo = "pdf";

    let _id_agua = new ParametroJasper();
    _id_agua.nombre = "_id_agua";
    _id_agua.valor = this.idAgua + "";
    await this.auxJasper.ParametroJasper.push(_id_agua);

    let _cuenta_agua = new ParametroJasper();
      _cuenta_agua.nombre = "_cuenta_agua";
      _cuenta_agua.valor = this.cuentaAgua + "";
      await this.auxJasper.ParametroJasper.push(_cuenta_agua);

    this.showDialog();

  } catch (error) {
    if (error.response) throw { message: error.response.data };
    else throw error;
  }
}

  async abreOrdenesTrabajo() {
    try {
      
      this.ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
      this.ordenesTrabajoInput.cuentaAgua = this.cuentaAgua;
      await this.getAllConsultaOrdenesTrabajo(this.ordenesTrabajoInput);

      this.ConsultaOrdenesInput$.emit(this.consultaOrdenesTrabajo);


      this.displayOrdenes = true;

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }finally{
      console.log("Paso por abreOrdenesTrabajo");
    }
  }


  async abreDomiciliacion() {
    try {
      let domiciliacion = new Domiciliacion();
      domiciliacion.idAgua = this.idAgua;
      this.domiciliacion$.emit(domiciliacion);
      this.displayDomiciliacion = true;
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }finally{
      console.log("Paso por abreDomiciliacion");
    }
  }

  async getAllConsultaOrdenesTrabajo(OrdenesTrabajoInput) {
    try {

      this.consultaOrdenesTrabajo = [];

      const datoRetorno = await this.consultaOrdenesTrabajoService.getAll(OrdenesTrabajoInput).toPromise();

      for (var i = 0, len = datoRetorno?.length; i < len; ++i){
        let element:ConsultaOrdenesTrabajo = JSON.parse(datoRetorno[i].renglon)
        element.fechaAlta = new Date(element.fechaAlta);
        this.consultaOrdenesTrabajo.push(element[0])
      }

      for (var i = 0, len = this.consultaOrdenesTrabajo?.length; i < len; ++i){
        this.consultaOrdenesTrabajo[i].numRow = i;
        this.consultaOrdenesTrabajo[i].cambio = false;
        this.consultaOrdenesTrabajo[i].baja = false;
      }


    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllConsultaOrdenesTrabajo");
    }
  }


  async consultaEtapas(event:ConsultaOrdenesTrabajo){ 
    try {
      
      this.OrdenTrabajo = event;
      this.EtapasOrdenes = [];

      if(event.id == 0){
      }else{
         //si se trata de una orden existente se consulta etapas que contengan
        let imput = new ConsultaOrdenesTrabajoInput()
        imput.idSolicitud = event.id;
        imput.cuentaAgua = null;
        imput.numOrdenT = null;

        const datoRetorno = await this.flujoOrdenesService.getBusquedas(imput).toPromise();


        for (var i = 0, len = datoRetorno.length; i < len; ++i){

          let element = JSON.parse(datoRetorno[i].renglon)
          let etapasOrdenesNuevo = new EtapasOrdenes()
          etapasOrdenesNuevo = {...element[0]}
    
          etapasOrdenesNuevo.numRow = i;
          etapasOrdenesNuevo.cambio = false;
          etapasOrdenesNuevo.baja   = false;

          this.EtapasOrdenes.push(etapasOrdenesNuevo)
         
        };

        //ordena por id solicitud_etapas_tramite
        this.EtapasOrdenes.sort((a, b) => a.id - b.id);
        
      };

      // si la orden seleccionada esta cancelada no tiene caso mostrar etapas o flujo
      if(this.OrdenTrabajo.idEstatus == 4){
        this.EtapasOrdenes = [] ;
      };
      
      this.etapasOrdenesInput$.emit(this.EtapasOrdenes)

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }finally{
    
    };
  };

  async imprimirReciboHistorico()
  {
    try {
      let objUrl = new Privilegios();
      objUrl.uuid = '6f69ab44-a8b5-431a-8adc-189b477b49a4';
      let conPrivilegio = await this.privilegiosService.GetPrivilegioByUUID(objUrl).toPromise(); 

      if(conPrivilegio)
        {
          this.auxJasper = new AuxJasper();
          this.auxJasper.JasperReport.nombreReporte = "EstadoDeCuenta";
          this.auxJasper.JasperReport.tipo = "pdf";
          
          let _id_agua = new ParametroJasper();
          _id_agua.nombre = "_id_agua";
          _id_agua.valor = this.idAgua + "";
          await this.auxJasper.ParametroJasper.push(_id_agua); 
    
          let reimpresion = new ParametroJasper();
          reimpresion.nombre = "reimpresion";
          reimpresion.valor = "true";
          await this,this.auxJasper.ParametroJasper.push(reimpresion);

          let reimpresionFlag = new ParametroJasper();
          reimpresionFlag.nombre = "_reimpresion_recibo";
          reimpresionFlag.valor = "true";
          await this,this.auxJasper.ParametroJasper.push(reimpresionFlag);
    
          this.showDialog();
        } 
      else throw new Error('No cuenta con privilegios.')
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por imprimirReciboHistorico");
    }
  }

  
  handleDialogClose() {
    this.reimpresionComponent.limpiar(); // <-- Llama el método del hijo
  }
}